import BigNumber from "bignumber.js";
import * as interpolate from "interpolate";
import i18n from "../i18n";
import { HTML_INTERPOLATION_DELIMITER } from "./constants";
import { omit } from "ramda";

enum ReferenceLanguage {
	EN = "en",
	ES = "es",
}

const referenceLanguages = [
	ReferenceLanguage.EN.toString(),
	ReferenceLanguage.ES.toString(),
];

export const printNumber = (n, decimalPlaces = 2) =>
	n || n == 0 ? new BigNumber(n).toFixed(decimalPlaces) : "-";

export const radToDeg = (radians: number) => radians * (180 / Math.PI);

export const getRequestObject = () => ({
	success: null,
	error: null,
	loading: false,
});

export function translateHtml(html: string, locales: any) {
	if (!locales || !locales[i18n.language] || !html) {
		return html;
	}
	const currentLocales = buildLocales(locales, i18n.language);

	return interpolate(html, currentLocales, {
		delimiter: HTML_INTERPOLATION_DELIMITER,
	});
}

export function translate(value: string, locales: any) {
	if (!value || !value.startsWith("$") || !locales || !locales[i18n.language]) {
		return value;
	}
	const languageKeyMap = buildLocales(locales, i18n.language);

	return languageKeyMap[value.slice(1)] || value;
}

export function isReferenceLanguage(language: string) {
	return referenceLanguages.includes(language);
}

function buildLocales(locales: any, language: string) {
	if (!referenceLanguages.includes(language)) {
		const missingKeys = omit(
			Object.keys(locales[language]),
			locales[ReferenceLanguage.EN]
		);

		return { ...locales[language], ...missingKeys };
	}
	return locales[language];
}
